import type { Resource } from '../../';
export const product_details_contentBlocks_freeShipping_modal_paragraph1: Resource = {"default":"Full Priced orders over $50 will be offered free standard shipping within the contiguous United States."};
